import {
  // We are wrapping the Typography component in this component
  // eslint-disable-next-line no-restricted-imports
  Typography,
  type TypographyProps,
} from '@mui/material';
import { type ForwardedRef, forwardRef } from 'react';

import { TypographyColorMap } from './constants.js';
import {
  type CodeVariant,
  MUI_VARIANTS,
  type TypographyVariant,
  codeVariants,
} from './variants.js';
import { mergeSxProps } from '../Mui/mergeSxProps.js';

export interface TextProps extends Omit<TypographyProps<'p'>, 'component' | 'as' | 'variant'> {
  variant?: TypographyVariant;
  bold?: boolean;
  component?: 'span' | 'label';
}

export const Text = forwardRef((props: TextProps, ref: ForwardedRef<HTMLParagraphElement>) => {
  const { variant = 'body1', bold, sx, color, component, ...rest } = props;
  const isCodeVariant = codeVariants.has(variant as CodeVariant);
  return (
    <Typography
      {...rest}
      ref={ref}
      component={component ?? (isCodeVariant ? 'pre' : 'p')}
      variant={MUI_VARIANTS[variant]}
      sx={mergeSxProps(
        { color: typeof color === 'string' ? (TypographyColorMap[color] ?? color) : color },
        bold ? { fontWeight: 700 } : {},
        sx
      )}
    />
  );
});

Text.displayName = 'Text';
